module.exports = __webpack_public_path__ + "img/top_bg.364ce1d1.png";